module.exports = __webpack_public_path__ + "static/media/settings.dd2fa63f.svg";